export default [
    {
        path: '/',
        name: 'index',
        component: () => import('@/views/modules/Home'),
        meta: {
          requiresAuth:true,
          layout: 'app',
          title: 'Home',
          breadcrumb: [
            { text: 'Home',  to: { name: "home" } },
            { text: 'Summary' }
          ]
        }
      },
    {
        path: "/support",
        name: "support",
        component: () => import("@/views/Support"),
        meta: {
            layout: "base"
        }
    },
    {
        path: "/no-location",
        name: "no-location",
        component: () => import("@/views/NoLocation"),
        meta: {
            layout: "base"
        }
    },
 
    {
        path: "/update",
        name: "update",
        component: () => import("@/views/Update"),
        meta: {
            layout: "base"
        }
    },

 
    {
        path: "*",
        name: "404",
        component: () => import("@/views/Error"),
        meta: {
            layout: "base"
        }
    }
];
